import type { InsuranceFeatureConfig } from '../types/InsuranceFeatureConfig';
import { claimsConfig } from './configByFeature/claims';
import { dashboardConfig } from './configByFeature/dashboard';
import { fundsConfig } from './configByFeature/funds';
import { modificationsConfig } from './configByFeature/modifications';
import { servicingConfig } from './configByFeature/servicing';
import { accidentConfig } from './configByInsuranceType/accident';
import { carConfig } from './configByInsuranceType/car';
import { healthConfig } from './configByInsuranceType/health';
import { lifeConfig } from './configByInsuranceType/life';
import { productConfig } from './configByInsuranceType/product';
import { propertyConfig } from './configByInsuranceType/property';
import { travelConfig } from './configByInsuranceType/travel';

export const insurances: Partial<InsuranceFeatureConfig> = {
    defaultRoute: 'overview',
    showManageInsurance: false,
    relyOnWebAPIAlias: true,
    showCurrentCapitalValue: true,
    claims: claimsConfig.HR,
    dashboard: dashboardConfig.HR,
    funds: fundsConfig.HR,
    modifications: modificationsConfig.HR,
    servicing: servicingConfig.HR,
    accident: accidentConfig.HR,
    car: carConfig.HR,
    health: healthConfig.HR,
    life: lifeConfig.HR,
    product: productConfig.HR,
    property: propertyConfig.HR,
    travel: travelConfig.HR,
};
